// extracted by mini-css-extract-plugin
export default {"inputbox":"_1wt8q7hCWVFBuLrqHgD8OY","button":"_2CJITV5y1TxpyNBPUbqFNX"};